import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HeaderUserBlock from '../Common/HeaderUserBlock';
import AlertBar from '../Common/AlertBar';
import { toggleSetting } from '../../actions/layoutActions';
import { isTeamUser } from '../../utils/authUtils';
import browserHistory from '../../history';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mobileMenuOpen: false };
    this.mobileMenuContainerRef = React.createRef();
  }

  componentDidMount() {
    this.docClickHandler = (e) => {
      if (!this.state.mobileMenuOpen) return;
      const el = this.mobileMenuContainerRef.current;
      if (el && el.contains(e.target)) return;
      this.setState({ mobileMenuOpen: false });
    };
    document.addEventListener('click', this.docClickHandler, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.docClickHandler, true);
  }

  toggleMobileMenu = () => {
    this.setState((s) => ({ mobileMenuOpen: !s.mobileMenuOpen }));
  };

  closeMobileMenuAndLogout = () => {
    this.setState({ mobileMenuOpen: false });
    this.props.onLogout();
  };

  toggleCollapsed = (e) => {
    const { doToggleSetting } = this.props;
    e.preventDefault();
    doToggleSetting('isCollapsed');
  };

  toggleAside = (e) => {
    const { doToggleSetting } = this.props;
    e.preventDefault();
    doToggleSetting('asideToggled');
  };

  goBack = () => {
    browserHistory.goBack();
  };

  render() {
    const { type = 'auth', user, team, step, showStepNumber = false, showBackButton = false, onBack } = this.props;
    const showProgress = step && step > 0;
    const handleBack = typeof onBack === 'function' ? onBack : this.goBack;
    let roles;
    let settings;
    let name;
    let logo_url;
    let subscription;
    let status;

    if (team) {
      ({ settings, subscription } = team);
      if (settings) {
        ({ name, logo_url } = settings);
      }
      if (subscription) {
        ({ status } = subscription);
      }
    }
    if (user) {
      ({ roles } = user);
    }

    const signOutContent = (
      <>
        <em className="fas fa-sign-out-alt" />
        <span>Sign Out</span>
      </>
    );

    return (
      <header className="topnavbar-wrapper">
        <AlertBar team={team} user={user} />
        {type !== 'pre' ? (
          <nav className="navbar topnavbar">
            {type !== 'noNav' && (
              <>
                <div className="navbar-header">
                  <a className="navbar-brand" href="/">
                    {isTeamUser(roles) ? (
                      <>
                        {logo_url ? (
                          <div className="brand-logo">
                            <img
                              className="img-fluid"
                              src={logo_url}
                              title={`${name}, powered by Macrostax`}
                            />
                          </div>
                        ) : (
                          <>
                            <div className="team-name">{name}</div>
                            <div className="caption">Powered by Macrostax</div>
                          </>
                        )}
                      </>
                    ) : (
                      <div className="brand-logo">
                        <img className="img-fluid" src="/img/logo.png" alt="Macrostax" />
                      </div>
                    )}
                  </a>
                </div>

                <ul className="navbar-nav mr-auto flex-row">
                  <li className="nav-item">
                    <a
                      href=""
                      className="nav-link sidebar-toggle d-md-none"
                      onClick={this.toggleAside}
                    >
                      <em className="fas fa-bars" />
                    </a>
                  </li>
                </ul>
              </>
            )}

            {type === 'auth' && user && user.first_name && (
              <ul className="navbar-nav flex-row">
                <HeaderUserBlock />
              </ul>
            )}
          </nav>
        ) : (
          <>
          <nav className="navbar topnavbar header-preauth-nav">
            <a className="navbar-brand" href="/">
              <div className="brand-logo">
                <img className="img-fluid" src="/img/macrostax-logo.png" alt="Macrostax" />
              </div>
            </a>
            {this.props.onLogout && (
              <>
                <div
                  className="d-none d-md-flex align-items-center"
                  style={{ position: 'absolute', right: '1rem', top: 0, bottom: 0 }}
                >
                  <button type="button" className="header-signout-link" onClick={this.props.onLogout}>
                    {signOutContent}
                  </button>
                </div>
                  <div className="d-flex d-md-none" ref={this.mobileMenuContainerRef}>
                    <div className="header-mobile-menu-btn-wrap">
                      <button
                        type="button"
                        className="header-mobile-menu-btn"
                        onClick={this.toggleMobileMenu}
                        aria-expanded={this.state.mobileMenuOpen}
                        aria-label={this.state.mobileMenuOpen ? 'Close menu' : 'Open menu'}
                      >
                        <em className={`fas ${this.state.mobileMenuOpen ? 'fa-times' : 'fa-bars'}`} />
                      </button>
                    </div>
                    {this.state.mobileMenuOpen && (
                      <div className="header-mobile-menu d-md-none">
                        <div
                          className="header-mobile-menu-backdrop"
                          onClick={this.toggleMobileMenu}
                          aria-hidden
                        />
                        <div className="header-mobile-menu-panel">
                          <button
                            type="button"
                            className="header-mobile-menu-item header-signout-link-style"
                            onClick={this.closeMobileMenuAndLogout}
                          >
                            {signOutContent}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </>
            )}
            {showProgress && (
              <div className="signup-progress-bar-container">
                {step !== 1 && step !== 12 && (
                  <div className="arrow-back" onClick={this.goBack}>
                    <em className="mr-2 fas fa-arrow-left" />
                  </div>
                )}
                <div className="step-number">
                  {showStepNumber ? <>{step < 5 ? <>Step {step}/4</> : <>Order Complete</>}</> : <>&nbsp;</>}
                </div>

                <div className="progress-bar">
                  <div className={`progress step-${step}`}></div>
                </div>
              </div>
            )}
            {!showProgress && showBackButton && (
              <div className="header-back-container">
                <button type="button" className="arrow-back" onClick={handleBack} aria-label="Back">
                  <em className="mr-2 fas fa-arrow-left" />
                </button>
              </div>
            )}
          </nav>
          </>
        )}
      </header>
    );
  }
}

Header.propTypes = {
  doToggleSetting: PropTypes.func,
  type: PropTypes.string,
  step: PropTypes.number,
  showStepNumber: PropTypes.bool,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
};

const mapStateToProps = (state) => ({
  settings: state.settings,
  team: state.team,
  user: state.auth.user,
});
const mapDispatchToProps = (dispatch) => ({
  doToggleSetting: (setting) => dispatch(toggleSetting(setting)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
